import React from 'react';
import Form from '../../../CommonComponents/Form';
import { Input } from '../../../CommonComponents/OPL/Input/Input';
import { InputNumberMask } from '../../../CommonComponents/OPL/Input/InputNumberMask';

import InstitutionAutoComplete from '../../../InstitutionAutocomplete/InstitutionAutoCompleteContainer';

import withForm from './withForm';

const NonInvestmentAccountForm = ({ account, onUpdate, isEditable }) => (
  <Form>
    <Form.Control>
      <InputNumberMask
        leftIcon="fa fa-dollar-sign"
        allowNegative={false}
        label="Balance"
        disabled={!isEditable}
        value={account.NonSpecificPositionsValue}
        onChange={({ target: { value } }) => onUpdate({ NonSpecificPositionsValue: value })}
        {...(isEditable ? {} : { allowNegative: true })}
      />
    </Form.Control>
    <Form.Control>
      <Input
        label="Description"
        disabled={!isEditable}
        value={account.AccountName}
        onChange={({ target: { value } }) => onUpdate({ AccountName: value })}
      />
    </Form.Control>
    <Form.Control>
      <InstitutionAutoComplete
        label="Institution"
        disabled={!isEditable}
        placeholder="Search..."
        value={{ label: account.InstitutionName, value: account.InstitutionId }}
        onChange={({ value, label }) => onUpdate({ InstitutionId: value, InstitutionName: label })}
      />
    </Form.Control>
  </Form>
);

export default withForm(NonInvestmentAccountForm);
